<section *ngIf="errors && show">
  <ng-container *ngFor="let error of errors.slice(0, 1)">
    <p *ngIf="error" class="errors"><i class="fal fa-triangle-exclamation"></i>&nbsp;{{error}}</p>
  </ng-container>
</section>
